"use client";

import { useEffect, useState } from "react";
import NotificationManager from "./NotificationManager";
import Notifications from "./Notifications";
import { reaction, values } from "mobx";
import { observer } from "mobx-react";
import SafeRouter from "../utilities/SafeRouter";
import { useStores } from "../../stores/useStores";
import URI from "urijs";

export const NotificationContainer = observer(
  (props: { enterTimeout?: number; leaveTimeout?: number }) => {
    const { enterTimeout = 400, leaveTimeout = 400 } = props;
    const [notifications, setNotifications] = useState([]);
    const { interfaceStore } = useStores();

    useEffect(() => {
      const disabler = reaction(
        () => values(NotificationManager.listNotify),
        handleStoreChange,
      );
      return () => disabler();
    }, []);

    useEffect(() => {
      const notifyQueryParam = "notify";
      const currentFullUrlParts = URI(interfaceStore.currentFullUrl);
      if (currentFullUrlParts.hasQuery(notifyQueryParam)) {
        const query = currentFullUrlParts.query(true);
        const notify = JSON.parse(query[notifyQueryParam]);
        if (NotificationManager[notify.type]) {
          setTimeout(() => {
            // Hacky... but without setTimeout there is a jarring re-render of SchoolBlocksPageWrapper and this
            // was the only way found to avoid it. When SchoolBlocksPageWrapper is a server component, it can
            // likely be removed.
            NotificationManager[notify.type](notify.message, undefined, 5000);
            SafeRouter.setQuery(notifyQueryParam, undefined);
          }, 1000);
        }
      }
    }, []);

    function handleStoreChange(notifications) {
      setNotifications(notifications);
    }

    function handleRequestHide(notification) {
      NotificationManager.remove(notification);
    }

    return (
      <Notifications
        enterTimeout={enterTimeout}
        leaveTimeout={leaveTimeout}
        notifications={notifications}
        onRequestHide={handleRequestHide}
      />
    );
  },
);
